/**
 * Best-effort haptic tick for touch interactions.
 *
 * navigator.vibrate() is the web's only haptics API: supported by
 * Android Chrome/Firefox, NOT by iOS Safari (WebKit ships no vibration
 * API - real iOS haptics are only reachable through a native wrapper,
 * e.g. the Capacitor shell can bridge Haptics.impact when the mobile
 * app lands). Silent no-op wherever unsupported, so callers can
 * sprinkle it on meaningful touch moments (long-press, filter apply,
 * verification success) without feature checks.
 */
export function haptic(pattern: number | number[] = 10) {
  try {
    if (typeof navigator !== "undefined" && "vibrate" in navigator) {
      navigator.vibrate(pattern);
    }
  } catch {
    // Browsers may reject vibrate() without user activation; ignore.
  }
}
